// CSV export of the payments list: file format and the download itself

// Column order of the exported file
const columns = [
  { key: 'date', title: 'Date' },
  { key: 'method', title: 'Method' },
  { key: 'id', title: 'ID' },
  { key: 'purpose', title: 'Purpose' },
  { key: 'teamName', title: 'Team' },
  { key: 'tournamentName', title: 'Tournament' },
  { key: 'amount', title: 'Amount' },
  { key: 'currency', title: 'Currency' },
];

// Excel keeps a bare comma-separated field in one cell only when it is quoted,
// and reads a doubled quote as a literal one
const escapeValue = (value) => {
  if (value === null || value === undefined) return '';

  const text = String(value);
  // A leading =, +, - or @ runs the cell as a formula in Excel, and team names
  // are typed by their coaches. Numbers are exempt: a refund stays a number
  const safe =
    typeof value === 'string' && /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;

  return /[",\r\n]|^\s|\s$/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

const toCsv = (rows) => {
  const lines = [columns.map((col) => escapeValue(col.title)).join(',')];

  for (const row of rows)
    lines.push(columns.map((col) => escapeValue(row[col.key])).join(','));

  // Without the BOM Excel opens the file as the local codepage and mangles
  // every non-ASCII name in it
  return '\uFEFF' + lines.join('\r\n');
};

// `rows` are the flat rows the grid and the PDF read, so the three cannot
// drift apart
export const exportPaymentsCsv = (filename, rows) => {
  const blob = new Blob([toCsv(rows)], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.download = filename;
  link.href = url;

  // Firefox follows a click only on an anchor that is in the document, and
  // revoking before the browser has read the blob cancels the download
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
